<template>
  <div class="p-4">
    <div v-if="loading" class="text-gray-500">Cargando datos...</div>

    <div v-else>
      <div class="card-header bg-light fw-bold">
        <span class="material-icons align-middle me-1" style="font-size:18px">manage_search</span>
        Información de auditoría
      </div>

      <div v-if="auditoria.length">
        <h3 class="text-lg font-semibold mt-4">Cambios Generales</h3>
        <table class="w-full table-auto border mt-2">
          <thead class="bg-gray-100">
            <tr>
              <th class="border px-2 py-1">Fecha</th>
              <th class="border px-2 py-1">Usuario</th>
              <th class="border px-2 py-1">Operación</th>
              <th class="border px-2 py-1">Campo</th>
              <th class="border px-2 py-1">Antes</th>
              <th class="border px-2 py-1">Después</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in auditoria" :key="item.idAuditoria">
              <td class="border px-2 py-1">{{ item.fecha }}</td>
              <td class="border px-2 py-1">{{ item.usuario }}</td>
              <td class="border px-2 py-1">{{ item.operacion }}</td>
              <td class="border px-2 py-1">Número</td>
              <td class="border px-2 py-1">{{ item.numeroPlanillaAnterior }}</td>
              <td class="border px-2 py-1">{{ item.numeroPlanillaNuevo }}</td>
            </tr>
            <!-- Puedes extender aquí para más campos si lo deseas -->
          </tbody>
        </table>
      </div>
      <div v-else class="text-gray-500">No se encontró auditoría para esta planilla.</div>

      <div v-if="detalle.length">
        <h3 class="text-lg font-semibold mt-6">Cambios Detallados</h3>
        <table class="w-full table-auto border mt-2">
          <thead class="bg-gray-100">
            <tr>
              <th class="border px-2 py-1">Fecha</th>
              <th class="border px-2 py-1">Usuario</th>
              <th class="border px-2 py-1">Operación</th>
              <th class="border px-2 py-1">Código</th>
              <th class="border px-2 py-1">Antes</th>
              <th class="border px-2 py-1">Después</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in detalle" :key="item.idAuditoria">
              <td class="border px-2 py-1">{{ item.fecha }}</td>
              <td class="border px-2 py-1">{{ item.usuario }}</td>
              <td class="border px-2 py-1">{{ item.operacion }}</td>
              <td class="border px-2 py-1">{{ item.codigoAnterior }}</td>
              <td class="border px-2 py-1">{{ item.descripcionAnterior }}</td>
              <td class="border px-2 py-1">{{ item.descripcionNueva }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue';
import api from "@/services/api";

export default {
  name: 'ConsultaAuditoriaPlanilla',
  props: {
    idPlanilla: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const auditoria = ref([]);
    const detalle = ref([]);
    const loading = ref(false);

    const cargarDatos = async () => {
      if (!props.idPlanilla) return;
      loading.value = true;
      try {
        const [resAuditoria, resDetalle] = await Promise.all([
          api.get(`/auditoria/planilla/planilla/${props.idPlanilla}`),
          api.get(`/auditoria/planilla/planilla/${props.idPlanilla}/detalle`)
        ]);
        auditoria.value = resAuditoria.data;
        detalle.value = resDetalle.data;
      } catch (error) {
        console.error('Error al cargar auditoría:', error);
      } finally {
        loading.value = false;
      }
    };

    onMounted(cargarDatos);
    watch(() => props.idPlanilla, cargarDatos);

    return {
      auditoria,
      detalle,
      loading
    };
  }
};
</script>

<style scoped>
table {
  border-collapse: collapse;
}
</style>